import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import Title from "../../../Models/Catalogue/Generic/Title";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class TitleCatalogueEntry extends CatalogueEntry<Title> {

    constructor() {
        super("Titles", Title);
    }

    public get editRole() {
        return CatalogueRoles.Title.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.titles;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveTitles;
    }
    
    public renderRow(item: Title, meta: Model.TransformMetaType<Title>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.titleName} />
                <NeoGrid.Column bind={meta.pronoun} headerTooltip="E.g. his / her for use in letters." />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}